export const config = {
  events: 'submit|blur',
  dictionary: {
    en: {
      attributes: {
        firstname:"first name",
        lastname:"last name",
        firstName:"first name",
        lastName:"last name",
        email: 'email',
        password: 'password',
        repeatPassword: 'repeat password',
        phoneNumber: 'phone number',
        amount: 'amount',
        payor: 'payor',
        recipient: 'recipient',
        paymentDate: 'payment date',
        dateFrom: 'date from',
        dateTo: 'date to',
        amountFrom: 'amount from',
        amountTo: 'amount to',
        originalDateFrom: 'date from',
        originalDateTo: 'date to',
        originalAmountFrom: 'amount from',
        originalAmountTo: 'amount to',
        reimbursementDateFrom: 'date from',
        reimbursementDateTo: 'date to',
        reimbursementAmountFrom: 'amount from',
        reimbursementAmountTo: 'amount to',
        currentPassword: 'current password',
        newPassword: 'new password',
        confirmPassword: 'confirmed password',
        coparent: 'co-parent',
        paidBy: 'originally paid by',
        owedBy: 'owed by',
        totalAmount: 'total amount',
        reimbursementAmount: 'reimbursement amount',
        myShare: 'my share',
        coparentsShare: 'co-parent"s share',
        interval: 'interval unit',
        endUnitL: 'end unit',
        countryCode: 'country',
        address: 'address',
        city: 'city',
        postalCode: 'postal code',
        ssn: 'SSN',
        states: 'state',
        birthDate: 'birth date',
        eventTitle: 'event title',
        children: 'children',
        bankInstitution: 'bank institution',
        bankUsername: 'username',
        bankPassword: 'password',
        accountType: 'account type',
        bankAccount: 'bank account',
        mfaSelection: 'answer',
        mfaWord: 'answer',
        mfaAnswer1: 'answer',
        mfaAnswer2: 'answer',
        accountNumber: 'account number',
        mfaAmount1: 'amount',
        mfaAmount2: 'amount'
      },

      custom: {
        amount: {
          min_value: 'The amount field must be number greater than 1.'
        },
        intervalDuration: {
          decimal: 'The interval duration must be a positive integer.',
          min_value: 'The interval duration must be a positive integer.',
          numeric: 'The value must be a whole and a positive number.'
        },
        endDuration: {
          decimal: 'The value must be a whole number.',
          min_value: 'The value must be a positive number.',
          numeric: 'The value must be a whole and a positive number.',
          max_value: 'The value of this field must be 100 or less.'
        },
        repeatDuration: {
          min_value: 'The value must be a positive number.',
          numeric: 'The value must be a whole and a positive number.',
          max_value: 'The value of this field must be 100 or less.'
        },
        children: {
          min: 'You must choose the parents first.',
        }
      }
    }
  }
};
